import { render, staticRenderFns } from "./employeeCerformanceList.vue?vue&type=template&id=2f20da64&scoped=true"
import script from "./employeeCerformanceList.vue?vue&type=script&lang=js"
export * from "./employeeCerformanceList.vue?vue&type=script&lang=js"
import style0 from "./employeeCerformanceList.vue?vue&type=style&index=0&id=2f20da64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f20da64",
  null
  
)

export default component.exports